import {createTheme} from '@mui/material/styles';
import {baseTheme} from './baseTheme';
import {baseComponentOverrides} from './baseComponentOverrides';
import {breakpointOverrides} from './breakpointOverrides';
import * as jdGreenTokens from '@deere/fuel-tokens/dist/web/jd-green/tokens';
import * as jdBlackTokens from '@deere/fuel-tokens/dist/web/jd-black/tokens';

export const jdGreen = createTheme(baseTheme, {
    name: 'jdGreen',
    breakpoints: {
        ...breakpointOverrides
    },
    palette: {
        text: {
            primary: jdGreenTokens.FuelColorTextPrimary,
            secondary: jdGreenTokens.FuelColorTextSecondary,
            disabled: jdGreenTokens.FuelColorTextDisabled
        },
        mode: 'light',
        primary: {
            main: jdGreenTokens.FuelColorBrandPrimary
        },
        secondary: {
            main: jdGreenTokens.FuelColorBrandPrimary
        },
        background: {
            default: jdGreenTokens.FuelColorBackgroundGray
        },
        divider: jdGreenTokens.FuelColorBorderLight,
        action: {
            hover: jdGreenTokens.FuelColorBackgroundActionDefaultHovered,
            selected: jdGreenTokens.FuelColorBackgroundActionDefaultSelected
        },
        error: {
            main: '#c21020'
        },
        grey: {
            '50': jdGreenTokens.FuelColorGray50,
            '100': jdGreenTokens.FuelColorGray100,
            '200': jdGreenTokens.FuelColorGray200,
            '300': jdGreenTokens.FuelColorGray300,
            '400': jdGreenTokens.FuelColorGray400,
            '500': jdGreenTokens.FuelColorGray500,
            '600': jdGreenTokens.FuelColorGray600,
            '700': jdGreenTokens.FuelColorGray700,
            '800': jdGreenTokens.FuelColorGray800,
            '900': jdGreenTokens.FuelColorGray900
        }
    },
    components: {
        ...baseComponentOverrides
    },
    tokens: {
        ...jdBlackTokens,
        ...jdGreenTokens
    }
});
